export const UNIT_STATUS = {
  0: "Running",
  1: "Paused",
};

export const UNIT_STATUS_BY_NAME = {
  Running: 0,
  Paused: 1,
};
